export const PROFILE_HEADER_FOOTER_BAR_BORDERS_WIDTH = 2
